<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

import { prefersReducedMotion } from '@/utils/onEnter'

const root = ref<HTMLElement | null>(null)
let raf = 0

const onMove = (event: MouseEvent): void => {
  const el = root.value
  if (el === null) return
  cancelAnimationFrame(raf)
  raf = requestAnimationFrame(() => {
    const cx = event.clientX / window.innerWidth - 0.5
    const cy = event.clientY / window.innerHeight - 0.5
    el.querySelectorAll<HTMLElement>('.blob').forEach((blob, i) => {
      const depth = (i + 1) * 18
      blob.style.marginLeft = `${cx * depth}px`
      blob.style.marginTop = `${cy * depth}px`
    })
  })
}

onMounted(() => {
  if (prefersReducedMotion()) return
  window.addEventListener('mousemove', onMove)
})

onUnmounted(() => {
  window.removeEventListener('mousemove', onMove)
  cancelAnimationFrame(raf)
})
</script>

<template>
  <div ref="root" class="backdrop">
    <div class="blob a"></div>
    <div class="blob b"></div>
    <div class="blob c"></div>
    <div class="grid"></div>
  </div>
</template>
